import React from "react";
import { DoubleRightOutlined, ExclamationCircleOutlined } from "@ant-design/icons";
const taskStatusUnassigned = "Unassigned";
const taskStatusPending = "Pending";

const taskStatusOffered = "Offered";

const taskStatusConfirmed = "Confirmed";
const taskStatusRejected = "Rejected";
const taskStatusNegotiating = "Negotiating";
const taskStatusInProgress = "In Progress";
const taskStatusCompleted = "Completed";

export const taskStatus = [
    {
        key: taskStatusUnassigned,
        name: taskStatusUnassigned,
        color: "#7e807f",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },

    {
        key: taskStatusPending,
        name: taskStatusPending,
        color: "#7e807f",
        ico: <DoubleRightOutlined />,
        selectable: true,
    }, //TODO: Remove Pending and use Offered
    {
        key: taskStatusOffered,
        name: taskStatusOffered,
        color: "#7e807f",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        key: taskStatusNegotiating,
        name: taskStatusNegotiating,
        color: "#dbc800",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        key: taskStatusConfirmed,
        name: taskStatusConfirmed,
        color: "#ddc652",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },

    {
        key: taskStatusInProgress,
        name: taskStatusInProgress,
        color: "#60a064",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        key: taskStatusCompleted,
        name: taskStatusCompleted,
        color: "#108ee9",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
    {
        key: taskStatusRejected,
        name: taskStatusRejected,
        color: "#eb2f96",
        ico: <DoubleRightOutlined />,
        selectable: true,
    },
];

export const isFinalStatus = (status) => {
    if (status === taskStatusCompleted) {
        return true;
    }
    return false;
};

export const getStatusColor = (status) => {
    const st = taskStatus.find((e) => e.key == status);
    return st ? st.color : "";
};
